import React, { Component } from "react";
import Header from "../header";

class rule extends Component {
  render() {
    return (
      <>
        <Header showSearchBar={true} title={"قوانین خرید اقساطی"} />

        <div className="rules">
          <iframe
            src="https://kacharlife.com/installment/mobile/rules"
            seamless
            style={{ border: "none", height: "88vh", width: "100vw" }}
            allow="fullscreen"
          />
        </div>
      </>
    );
  }
}
export default rule;
